import { Button, notification } from 'antd'
import { FC } from 'react'
import { dynamicRoutes, routes } from '../../../../../../../../../constants/routes'
import useErrorModal from '../../../../../../../../../hooks/api/use-error-modal'
import useShowStandardSuccessModal from '../../../../../../../../../hooks/use-show-standard-success-modal'
import useForm from '../../hooks/form/use-form'
import {
    useCreateStampOrderMutation,
    useUpdateStampOrderMutation,
} from '../../../../../../../../../store/api/stamp-orders-api'
import StampOrder from '../../../../../../../../../types/api/stamp-order'
import extractCreateStampOrderMutationArg from '../../helpers/extract-create-stamp-order-mutation-arg'
import { useCreateStampWriteOffMutation } from '../../../../../../../../../store/api/stamp-write-offs-api'
import extractCreateStampWriteOff from '../../../../../../../../../components/forms/stamp-write-off-form/helpers/extract-create-stamp-write-off'
import StampWriteOffFormValues from '../../../../../../../../../components/forms/stamp-write-off-form/types/form-values'

interface SaveProps {
    stampOrder?: StampOrder
    copy?: boolean
}

const Save: FC<SaveProps> = ({ stampOrder, copy }) => {
    const form = useForm()
    const showSuccessModal = useShowStandardSuccessModal('Заказ штампа сохранен', form)
    const [createStampOrder, createStampOrderState] = useCreateStampOrderMutation()
    const [updateStampOrder, updateStampOrderState] = useUpdateStampOrderMutation()
    const [createStampWriteOff, createStampWriteOffState] = useCreateStampWriteOffMutation()

    useErrorModal(createStampOrderState, 'Не удалось сохранить заказ штампа')
    useErrorModal(updateStampOrderState, 'Не удалось обновить заказ штампа')
    useErrorModal(createStampWriteOffState, 'Не удалось сохранить списание')

    const createStampWriteOffFormValues = (): StampWriteOffFormValues => {
        const values = form.getFieldsValue()

        return {
            stamp: values.stamp,
            reason: values.writeOff?.reason as StampWriteOffFormValues['reason'],
            initiator: values.writeOff?.initiator as StampWriteOffFormValues['initiator'],
        }
    }

    const onSave = async () => {
        try {
            await form.validateFields()
            const body = extractCreateStampOrderMutationArg(
                form
                // stampOrder && !copy ? stampOrder : undefined
            )
            const isEditing = stampOrder && !copy

            let result = null
            if (isEditing) result = await updateStampOrder({ docId: stampOrder.documentId, body })
            else result = await createStampOrder(body)

            if (copy) {
                const data = extractCreateStampWriteOff(createStampWriteOffFormValues())
                const resultOfStampWriteOffCreating = await createStampWriteOff(data)

                if ('data' in resultOfStampWriteOffCreating && resultOfStampWriteOffCreating.data) {
                    notification.success({ message: 'Списание сохранено' })
                }
            }

            if ('data' in result && result.data) {
                const { documentId } = result.data.data

                showSuccessModal({
                    listRoute: routes.purchasesStampOrders,
                    editingRoute: dynamicRoutes.purchasesStampOrder(documentId),
                })
            }
        } catch (e) {
            console.error(e)
        }
    }

    return (
        <Button
            type={'primary'}
            loading={createStampOrderState.isLoading || updateStampOrderState.isLoading}
            onClick={onSave}
        >
            Сохранить
        </Button>
    )
}

export default Save
